class CategoriesPDP {
	constructor(container) {
		this.container = container;
    this.sectionId = container.getAttribute('data-section-id');
    this.selectors = [
      '[data-block-type="categories_pdp_headline"]',
      '[data-block-type="categories_pdp_content"]'
    ];
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail.variant;
      if (!variant || !this.sectionId) return;
			this.updateCategories(variant.id);
		});
	}

  async updateCategories(variantId){
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', this.sectionId);

      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      this.selectors.forEach((selector) => {
        const fresh = doc.querySelector(selector);
        if (!fresh) return console.warn('CategoriesPDP: fresh block not found in fetched HTML');
        this.renderCategories(fresh, selector);
      });
    } catch (err) {
      console.error('CategoriesPDP: update failed', err);
    }
  }

  renderCategories(newContent, selector) {
    // Render the fetched categories in the container
    const content = this.container.querySelector(selector);
    content?.replaceWith(newContent);
  }

}

document.addEventListener("DOMContentLoaded", function() {
	const container = document.querySelector("[data-block-type='categories-pdp']");
	if (container) {
		new CategoriesPDP(container);
	}
});
